import React from "react";

const OurProcess = ({ steps, title = "Our Process", subtitle = "Simple, clear steps to deliver solutions" }) => {
  const defaultSteps = [
    {
      number: "01",
      title: "Discovery",
      description: "Understanding business needs & goals"
    },
    {
      number: "02", 
      title: "Design",
      description: "AI solution architecture & planning"
    },
    {
      number: "03",
      title: "Development", 
      description: "Model building, integration & testing"
    },
    {
      number: "04",
      title: "Deployment",
      description: "Optimization, scaling & support"
    }
  ];

  const processSteps = steps || defaultSteps;

  return (
    <div className="w-full py-16">
      {/* Section Header */}
      <div className="text-center mb-12">
        <h2 className="text-2xl font-semibold text-white mb-4">{title}</h2>
        <p className="text-white/60 max-w-2xl mx-auto">{subtitle}</p>
      </div>

      {/* Process Steps */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {processSteps.map((step, index) => (
          <div
            key={index}
            className="relative p-6 rounded-xl border border-white/10 bg-black/20 backdrop-blur-sm text-center"
          >
            {/* Step Number */}
            <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-primary/20 border border-primary/30 flex items-center justify-center">
              <span className="text-primary font-semibold text-sm">
                {step.number || String(index + 1).padStart(2, '0')}
              </span>
            </div>

            {/* Step Title */}
            <h3 className="text-lg font-medium text-white mb-2">{step.title}</h3>

            {/* Step Description */}
            <p className="text-white/70 text-sm leading-relaxed">{step.description}</p>

            {/* Connector Line - Hidden on last item and mobile */}
            {index < processSteps.length - 1 && (
              <div className="hidden lg:block absolute top-1/2 -right-3 w-6 h-px bg-gradient-to-r from-primary/60 to-transparent transform -translate-y-1/2" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default OurProcess;